<script setup>
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuPortal,
  DropdownMenuSubContent,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '@codinglabsau/gooey'
import { useNavigation } from '../../../Utils/useNavigation.js'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})

const { getHref } = useNavigation()
</script>

<template>
  <template v-for="item in items">
    <!-- Link Item -->
    <DropdownMenuItem
      v-if="item.component === 'Link'"
      :key="'Link-' + item.id"
      as="a"
      :href="getHref(item.href)"
      class="py-1.5"
    >
      <Component
        v-if="item.hasIcon && item.iconComponent"
        :is="item.iconComponent"
        class="size-4 mr-1"
      />
      {{ item.name }}
    </DropdownMenuItem>

    <!-- Nested Dropdown -->
    <DropdownMenuSub
      v-else-if="item.component === 'Dropdown'"
      :key="'Dropdown-' + item.id"
    >
      <DropdownMenuSubTrigger
        v-if="item.href !== null"
        as="a"
        class="cursor-pointer"
        :href="item.href"
      >
        <Component
          v-if="item.hasIcon && item.iconComponent"
          :is="item.iconComponent"
          class="size-4 mr-1"
        />
        {{ item.name }}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubTrigger
        v-else
        class="py-1.5"
      >
        <Component
          v-if="item.hasIcon && item.iconComponent"
          :is="item.iconComponent"
          class="size-4 mr-1"
        />
        {{ item.name }}
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          <!-- Recursively render the next level -->
          <RecursiveDropdown :items="item.items" />
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>

    <!-- Separator Item -->
    <DropdownMenuSeparator
      v-else-if="item.component === 'Separator'"
      :key="'separator-' + item.id"
    />

    <!-- Label Item -->
    <DropdownMenuLabel
      v-else-if="item.component === 'Label'"
      :key="'label-' + item.id"
    >
      {{ item.name }}
    </DropdownMenuLabel>
  </template>
</template>
